import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface PaymentPlanEditTemplateProps {
  readonly title: string;
  readonly children: ReactNode;
}

export function PaymentPlanEditTemplate({ title, children }: PaymentPlanEditTemplateProps) {
  const { t } = useTranslation('personManagement');

  return (
    <div className="flex flex-col gap-nano">
      <Breadcrumb>
        <BreadcrumbLink href="/">
          <Link to="/">
            <BreadcrumbIcon />
          </Link>
        </BreadcrumbLink>

        <BreadcrumbLink href="/persons">
          <Link to="/persons">{t('breadcrumb.persons')}</Link>
        </BreadcrumbLink>

        <BreadcrumbLink href="/persons/payments">
          <Link to="/persons/payments">{t('breadcrumb.payments')}</Link>
        </BreadcrumbLink>

        <BreadcrumbPage>{title}</BreadcrumbPage>
      </Breadcrumb>

      <h1 className="ts-heading-lg my-xxs text-ctx-content-title">{title}</h1>

      <div className="rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface p-md shadow-level1">
        {children}
      </div>
    </div>
  );
}
